<template>
  <b-form-checkbox-group
  value-field="value"
  :disabled="disabled"
  text-field="text"
  :class="{ 'flex-column': mode === 'vertical' }"
  :required="requiredCondition"
  class="d-flex"
  v-model="localValue"
  >
    <b-form-checkbox v-for="item in options"
    :key="item.value"
    :value="item.value"
    class="f-default checkbox my-2">
      {{ item.text }}
    </b-form-checkbox>
  </b-form-checkbox-group>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    label: {
      type: String,
      required: false,
      default: undefined
    },
    options: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      required: false,
      default: 'horizontal' // horizontal | vertical
    },
    value: {
      required: true
    }
  },
  data () {
    return {
      localValue: []
    }
  },
  watch: {
    localValue (newValue) {
      this.$emit('input', newValue)
    },
    value: {
      immediate: true,
      handler (value) {
        this.localValue = value
      }
    }
  },
  computed: {
    requiredCondition () {
      return this.required && this.local?.length === 0
    }
  }
}
</script>

<style>

</style>